/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import Modal from "react-responsive-modal";
import Button from "../../button";
import { CopyToClipboard } from "react-copy-to-clipboard";
// Interface for component Props
interface SaveResultsPopupProps {
  open: boolean;
  close: () => void;
  t?: any;
  questionType?: string;
  popupTitle: string;
  popupMessage: string;
  popupFirstButton: string;
  popupSecondButton: string;
  popupFirstButtonType: string;
}

// Interface for component State
interface SaveResultsPopupState {}

/**
 * Save Results Popup on results landing page.
 *
 * @namespace SaveResultsPopup
 */

class SaveResultsPopup extends Component<
  any,
  SaveResultsPopupProps,
  SaveResultsPopupState
> {
  constructor(props: SaveResultsPopupProps) {
    super(props);
    let htmlHeadElement = document.querySelector('head');
    let htmlMobileOnlyElement = document.querySelector('#MobileOnly');
    let htmlDefaultShareSupported = document.querySelector('#DefaultShareSupported');
    if(htmlHeadElement) {
      if (htmlMobileOnlyElement == null)
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent))
          htmlHeadElement.innerHTML += '<style id="MobileOnly">.MobileOnly{visibility:visible;}</style>';
        else
          htmlHeadElement.innerHTML += '<style id="MobileOnly">.MobileOnly{visibility:collapse;display:none;}</style>';
      if (htmlDefaultShareSupported == null)
        { // @ts-ignore
          if (navigator.share)
                    htmlHeadElement.innerHTML += '<style id="DefaultShareSupported">.DefaultShareSupported{visibility:visible;}</style>';
                  else
                    htmlHeadElement.innerHTML += '<style id="DefaultShareSupported">.DefaultShareSupported{visibility:collapse;display:none;}</style>';
        }
    }
  }

  /**
   * This method is used for handle Email Send
   *
   */
  handleFirstButtonClick = () => {
    if (this.props.popupFirstButtonType === "retake-assessment") {
      console.log("surveyPath",this.props.surveyType)
      localStorage.setItem("surveyType", this.props.surveyType);
      sessionStorage.removeItem("foundationalPageCount");
      localStorage.removeItem("reco-result");
      localStorage.removeItem("results")
      localStorage.removeItem("user-response");
      sessionStorage.removeItem("allQuestions");
      sessionStorage.removeItem("updatedInitialArray");
      sessionStorage.removeItem("dependencyArray");
      this.props.history.push("/foundational");
    }

    if (this.props.popupFirstButtonType === "sign-in") {
      localStorage.removeItem("results");
      localStorage.removeItem("totalCartProductsCount");
      const userConsent = localStorage.getItem("user-consent");
      if (!userConsent) {
        // sessionStorage.setItem("before-login-consent", "true");
        sessionStorage.removeItem("session-cleared");
        localStorage.setObj("isAuthCalled", false);
        localStorage.setItem(
          "previousPath",
          this.props.history?.location?.pathname?.includes("summary")
            ? "/results"
            : this.props.history?.location?.pathname
        );
        this.props?.oktaAuth?.signInWithRedirect();
        // window.location.reload();
      } else {
        localStorage.setObj("isAuthCalled", false);
        localStorage.setItem(
          "previousPath",
          this.props.history?.location?.pathname?.includes("summary")
            ? "/results"
            : this.props.history?.location?.pathname
        );
        this.props?.oktaAuth?.signInWithRedirect();
        sessionStorage.removeItem("login-session-expired");
        sessionStorage.removeItem("session-cleared");
      }
    }
  };
  copyText = () => {
    // console.log("copied");
  };
  // handleSignIn = () => {
  //   this.props?.oktaAuth?.signInWithRedirect();
  // };

  render() {
    const {
      open,
      questionType,
      popupTitle,
      popupMessage,
      popupFirstButton,
      popupSecondButton,
      popupFirstButtonType,
    } = this.props;
    return (
      <div>
        <Modal
          open={open}
          onClose={this.props.close}
          center
          classNames={{
            overlay: "custom-overlay",
            modal: "modal-container save-results-modal ",
            closeButton: "hide",
          }}
        >
          <div className="popup-wrapper">
            <div
              tabIndex={0}
              className="popup-close-icon"
              onClick={this.props.close}
              onKeyPress={(e: any) => {
                if (e.key === "Enter") {
                  this.props.close();
                }
              }}>
              <span className="icon close-icon"></span>
            </div>
            <div className="popup-header">
              <div className="popup-label">{popupTitle}</div>
              <div className="popup-description">{popupMessage}</div>
              <div className="popup-button-wrapper">
                {popupFirstButtonType === "linkshare" && (
                  <CopyToClipboard
                    text={popupMessage}
                    onCopy={() => this.copyText()}>
                    <div className="btn-wrapper">
                      <div className={"btn-area"}>
                        <button
                          accessKey="copyClicked"
                          className={"app-btn"}
                          onClick={this.props.close}
                          onKeyPress={(e: any) => {
                            if (e.key === "Enter") {
                              this.props.close();
                            }
                          }}>
                          {this.props.t("common.copy_link_text")}
                        </button>
                      </div>
                    </div>
                  </CopyToClipboard>
                )}

                {popupFirstButtonType === "linkshare" && (
                <div className="share-buttons">
                  <div className="share-button-box">
                    <div className="">
                      <button
                          className="amw-share-social__btn js-share-social-btn"
                          onClick={()=>{
                            window.open('mailto:?body=' +popupMessage, "_blank")
                          }}>

                        <i className="icon-envelope amw-share-social__icon"></i>
                        <span className="amw-share-social__btn-text xss-ml-8">Email</span>
                      </button>
                    </div>
                  </div>


                  <div className="share-button-box MobileOnly">
                    <div className="amw-share-social--small-icon">
                      <button className="amw-share-social__btn js-share-social-btn"
                              onClick={()=>{
                                window.open('sms:?&body='+popupMessage, "_blank")
                              }}>
                        <i className="icon-sms amw-share-social__icon" aria-hidden="true"></i>
                        <span className="amw-share-social__btn-text xss-ml-8">SMS</span>
                      </button>
                    </div>
                  </div>


                  <div className="share-button-box">
                    <div className="">
                      <button className="amw-share-social__btn js-share-social-btn"
                              onClick={()=>{
                                var ua = navigator.userAgent;

                                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
                                  window.open('fb-messenger://share/?link=' + popupMessage + '&app_id=1605091383193534', "_blank")
                                else {
                                  var FACEBOOK_URL = 'https://www.facebook.com/';
                                  var redirectUrl = encodeURIComponent(FACEBOOK_URL);

                                  window.open( FACEBOOK_URL + 'dialog/send?app_id=1605091383193534&link=' + popupMessage + '&redirect_uri=' + redirectUrl);
                                }
                              }}>

                        <i className="icon-messenger amw-share-social__icon" aria-hidden="true"></i>
                        <span className="amw-share-social__btn-text xss-ml-8">Messenger</span>
                      </button>
                    </div>
                  </div>


                  <div className="share-button-box">
                    <div className="">
                      <button className="amw-share-social__btn js-share-social-btn"
                              onClick={()=>{
                                window.open('https://api.whatsapp.com/send?text='+popupMessage, "_blank")
                              }}>

                        <i className="icon-whatsapp amw-share-social__icon" aria-hidden="true"></i>
                        <span className="amw-share-social__btn-text xss-ml-8">WhatsApp</span>
                      </button>
                    </div>
                  </div>


                  <div className="share-button-box DefaultShareSupported">
                    <div className="">
                      <button className="amw-share-social__btn js-share-social-btn" data-social="more"
                              onClick={()=>{
                                navigator.share({url:popupMessage});
                              }}>

                        <i className="icon-dots-three-horizontal amw-share-social__icon" aria-hidden="true"></i>
                        <span className="amw-share-social__btn-text xss-ml-8">More</span>
                      </button>
                    </div>
                  </div>


                </div>
                )}

                {popupFirstButton && (
                  <div className="btn-wrapper">
                    <Button
                      name={popupFirstButton}
                      className="app-btn"
                      onButtonClick={this.handleFirstButtonClick}
                    />
                  </div>
                )}
                {popupSecondButton && (
                  <div className="btn-wrapper">
                    <Button
                      name={popupSecondButton}
                      className="app-btn border-btn"
                      onButtonClick={() => {}}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="popup-bottom-section">
              <div
                tabIndex={0}
                role="button"
                className="label"
                onClick={this.props.close}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    this.props.close();
                  }
                }}
              >
                {this.props.t("common.close")}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default SaveResultsPopup;
